




























































import { Component, Prop, Vue } from "vue-property-decorator";
import MultiLevelObject from "@/interfaces/MultiLevelObject";

@Component({
  name: "multi-level-dropdown",
})
export default class MultiLevelDropdown extends Vue {
  @Prop() readonly options!: Array<MultiLevelObject>;
  @Prop({ default: false }) readonly nested?: boolean;
  @Prop() readonly headers?: Array<string>;
  @Prop({ default: 0 }) readonly level?: number;
  @Prop({ default: false }) readonly multiple?: boolean;
  @Prop() readonly parent?: MultiLevelObject;
  @Prop({ default: false }) readonly checkedIcon!: boolean;

  selected: MultiLevelObject | null = null;
  current: MultiLevelObject | null = null;

  timeOut: number | null = null;

  get header() {
    const level = this.level || 0;

    if (this.headers && this.headers.length) {
      return this.headers[level];
    } else {
      return null;
    }
  }

  get subLevel() {
    const level = this.level || 0;
    return level + 1;
  }

  get dropdownClass() {
    return {
      "multilevel-select__dropdown--nested": this.nested,
      "multilevel-select__dropdown": !this.nested,
      "multilevel-select__dropdown--with-header": this.header,
    };
  }

  created() {
    this.options.forEach((option) => {
      if (option.selected && option.children !== undefined) {
        this.updateChildren(option);
      }
    });
  }

  select(option: MultiLevelObject) {
    if (option.locked || (this.multiple && option.denyMultiselect)) {
      return;
    }
    if (this.multiple) {
      if (option.partial) {
        this.$set(option, "selected", true);
        this.$set(option, "partial", false);
      } else {
        if (option.selected == undefined || option.selected == false) {
          this.$set(option, "selected", true);
        } else {
          this.$set(option, "selected", false);
        }
      }

      this.updateChildren(option);
    }

    this.$emit("selected", option, this.level);
  }

  updateChildren(option: MultiLevelObject) {
    if (!option.children) {
      return;
    }

    option.children.forEach((child) => {
      this.$set(child, "selected", option.selected);

      if (option.selected) {
        this.$set(child, "partial", false);
      }

      this.updateChildren(child);
    });
  }

  updatePartial() {
    this.options.forEach((option) => {
      if (option.children) {
        const selected = option.children.filter(
          (child) => child.selected == true
        );

        if (selected.length == 0) {
          this.$set(option, "selected", false);

          const partials = option.children.filter(
            (child) => child.partial == true
          );
          this.$set(option, "partial", partials.length > 0);
        } else if (selected.length < option.children.length) {
          this.$set(option, "selected", false);
          this.$set(option, "partial", true);
        } else {
          this.$set(option, "selected", true);
          this.$set(option, "partial", false);
        }
      }
    });
  }

  childrenIsVisible(option: MultiLevelObject): boolean {
    if (this.current == null) {
      return false;
    }

    return this.current.id == option.id;
  }

  getSelectedOptions(options: MultiLevelObject[], level: number) {
    let selected: {
      [key: number]: string[];
    } = {};

    selected[level] = [];

    options.forEach((option) => {
      if (option.selected) {
        selected[level].push(option.id);
      }

      if (option.children && option.children.length) {
        selected = {
          ...selected,
          ...this.getSelectedOptions(option.children, level + 1),
        };
      }
    });

    return selected;
  }

  onNestedSelected(option: MultiLevelObject, level: number) {
    if (this.multiple) {
      this.updatePartial();
    }

    this.$emit("selected", option, level);
  }

  onEnter(option: MultiLevelObject) {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }

    this.current = option;
  }

  onLeave() {
    this.timeOut = setTimeout(() => {
      this.current = null;
      this.$emit("leave");
    }, 150);
  }
}
